import type { MediaImage } from '@efdigital/ll-addon-data';
import { getMediaImage } from '@efdigital/ll-admin-v2/data/builders/content/media-images';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { Store } from '@warp-drive/core';

export type ParamsMediaImageId = {
  media_image_id: string;
};

export type LibraryMediaImagesEditModel = ParamsMediaImageId & {
  mediaImage: MediaImage;
};

export default class LibraryMediaImagesEditRoute extends Route<LibraryMediaImagesEditModel> {
  @service declare store: Store;

  async model(params: ParamsMediaImageId) {
    return {
      ...params,
      mediaImage: (
        await this.store.request(getMediaImage(params.media_image_id))
      ).content.data,
    };
  }
}
